import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDvDs.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return /^(D[TV])$/.test(type)
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DT'},
                {type: 'DV'},
            ]
        },
    })
}
